import {TranslationKey} from '../keys'
import {TRANSLATION_AUTH_ID} from './auth'
import {TRANSLATION_FORKYGRAM_ID} from './forkygram'
import {TRANSLATION_GIFT_SHOP_ID} from './gift-shop'
import {TRANSLATION_GLOBAL_ID} from './global'
import {TranslationResource} from '../TranslationType'

export const TRANSLATION_ID: TranslationResource<TranslationKey> = {
  translation: {
    ...TRANSLATION_GLOBAL_ID.translation,
    ...TRANSLATION_AUTH_ID.translation,
    ...TRANSLATION_GIFT_SHOP_ID.translation,
    ...TRANSLATION_FORKYGRAM_ID.translation,
  },
}
